import { Component, OnInit } from '@angular/core';
import { MainDbVersion, TenantDbVersion } from 'projects/shared/src/lib/models/TenantDto';
import { DatabaseMigrationService } from 'projects/shared/src/lib/services/database-migration.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { ErrorFormat } from 'projects/shared/src/lib/util/error-format';

@Component({
  selector: 'database-updates',
  templateUrl: './database-updates.component.html',
  styleUrls: ['./database-updates.component.css']
})
export class DatabaseUpdatesComponent implements OnInit {

  databaseVersion!: MainDbVersion;
  tenantVersions: TenantDbVersion[] = [];
  errorMessage!: string;

  constructor(
    private databaseMigrationService: DatabaseMigrationService,
    public translate: TranslateService,
    private notificationService: NotificationService
  )
  { }

  ngOnInit() {
    this.refresh()
  }

  refresh() {
    this.databaseMigrationService.getCurrentVersion().subscribe({
      next: (version: MainDbVersion) => {
        this.databaseVersion = version;
        //console.log(this.databaseVersion)

        this.databaseMigrationService.getCurrentTenantDbVersions().subscribe({
          next: (versions: TenantDbVersion[]) => {
            this.tenantVersions = versions;
            //console.log("------------> database-updates: tenant versions = ", this.tenantVersions)
          },
          error: (error: any) => {
            //this.errorMessage = ErrorFormat.formatError(error);
            this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting tenant versions")
            this.notificationService.info("", error.error.developerMessage.Message)
            console.log("------------> database-updates: tenant dbs = ", error.error.developerMessage);
          }
        });   

      },
      error: (error: any) => {
        //this.errorMessage = ErrorFormat.formatError(error);
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error getting main db version")
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> database-updates: main db = ", error.error.developerMessage.Message);
      }
    });
  }
  updateMainDatabase() {
    this.databaseMigrationService.executeMainDbSqlQueries().subscribe({
      next: (data: any) => {
        // this.notificationService.success("", "Main database updated successfully")
        this.notificationService.success("", "Hauptdatenbank erfolgreich aktualisiert")
        this.refresh();
      },
      error: (error: any) => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error updating main database");
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> database-updates: main db = ", error.error.developerMessage.Message);
      }
    });
  }

  updateTenantDatabases() {
    this.databaseMigrationService.executeTenantDbsQueries().subscribe({
      next: (data: any) => {
        this.notificationService.success("", "Mandantendatenbanken erfolgreich aktualisiert")
        this.refresh();
      },
      error: (error: any) => {
        this.notificationService.error(`${this.translate.data["ERROR"]}`, "Error updating tenant databases");
        this.notificationService.info("", error.error.developerMessage.Message)
        console.log("------------> database-updates: tenant db = ", error.error.developerMessage.Message);
      }
    });
  }

}
